module.exports = __webpack_public_path__ + "static/media/44_A.7ab538a7.png";